import './index.css';
import { FaUserCog, FaKey } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

const Settings = () => {
  const navigate = useNavigate();

  return (
    <div className="dashboard">
      <h2>Settings</h2>
      <div className="activity-section">
        <div className="activity-card">
          <h5>Account Settings</h5>
          <ul>
            <li onClick={() => navigate('/owner-dashboard/settings/profile')}><FaUserCog /> Update Profile</li>
            <li onClick={() => navigate('/owner-dashboard/settings/password')}><FaKey /> Change Password</li>
          </ul>
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default Settings;
